module.exports = __webpack_public_path__ + "img/3@2x.a58b8578.png";